/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Company,
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompaniesListResponse
 */
export interface CompaniesListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof CompaniesListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<Company>}
     * @memberof CompaniesListResponse
     */
    entries: Array<Company>;
}

export function CompaniesListResponseFromJSON(json: any): CompaniesListResponse {
    return CompaniesListResponseFromJSONTyped(json, false);
}

export function CompaniesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompaniesListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(CompanyFromJSON)),
    };
}

export function CompaniesListResponseToJSON(value?: CompaniesListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(CompanyToJSON)),
    };
}


